module.exports = "https://static.zego.com/_next/static/images/social-private-hire-ver2-819bc4eb8a0420e8b423271a57169933.jpg";